import { Link, useLocation } from "react-router-dom";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { ProductCategory, Product } from "../../types/Generic";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

interface ProductSidebarProps {
  productCategory: ProductCategory;
  onProductSelect: (product: Product) => void;
}

const MobileProductSidebar: React.FC<ProductSidebarProps> = ({
  productCategory,
  onProductSelect,
}) => {
  const sidebarRef = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const currentPath = location.pathname;
  const { t } = useTranslation("products");
  const scrollSidebar = (direction: "left" | "right") => {
    if (sidebarRef.current) {
      const scrollAmount = 150;
      sidebarRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="sm:hidden py-4 flex items-center gap-4 w-full">
      <div className="flex justify-center py-4">
        <ArrowLeftIcon
          onClick={() => scrollSidebar("left")}
          sx={{ ":hover": { cursor: "pointer" }, color: "#000" }}
          className="border-2 rounded-full"
        />
      </div>

      <div
        ref={sidebarRef}
        className="flex w-full items-center overflow-x-auto no-scrollbar"
      >
        {productCategory.products?.map((item, index) => {
          const isActive = currentPath.includes(
            item.title.toLowerCase().replace(/\s+/g, "-")
          );

          return (
            <Link
              key={index}
              to={`${productCategory.path}/p=${item.title.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={(e) => {
                e.preventDefault();
                onProductSelect(item);
              }}
              className={`relative mr-4 w-min `}
            >
              <p
                className={`${
                  isActive ? "border-tertiary" : "border-gray-300"
                } whitespace-nowrap font-medium text-black text-center py-2 px-4 rounded-3xl border w-full`}
              >
                {t(item.title)}
              </p>
            </Link>
          );
        })}
      </div>

      <div className="flex justify-center">
        <ArrowRightIcon
          onClick={() => scrollSidebar("right")}
          sx={{ ":hover": { cursor: "pointer" }, color: "#000" }}
          className="border-2 rounded-full"
        />
      </div>
    </div>
  );
};

export default MobileProductSidebar;
